import { render, staticRenderFns } from "./IconCourse.vue?vue&type=template&id=0da52be8"
import script from "./IconCourse.vue?vue&type=script&lang=js"
export * from "./IconCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports